import { IconNameEnum } from "@b2bportal/core-themes";

export const CAR_AVAILABILITY_HEADER_SEPARATOR_ICON = IconNameEnum.rightArrow;
export const CAR_DATE_RANGE_SEPARATOR = " - ";
